import AuthProvider from './AuthProvider';
import { FirebaseProvider } from './FirebaseProvider';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export const AppProviders = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <FirebaseProvider>
      <AuthProvider>
        <div
          style={{
            background: 'white',
            width: '100%',
            height: '100%'
          }}
        >
          {children}
        </div>
      </AuthProvider>
    </FirebaseProvider>
  </QueryClientProvider>
);
